module.exports = __webpack_public_path__ + "img/devider.4a24cf60.svg";